// extracted by mini-css-extract-plugin
export default {"Container":"OpenCollectiveContribution_Container__NfkTB","slide":"OpenCollectiveContribution_slide__nuSli"};